import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/search",
  "use": "app/search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"app/search\"><path d=\"M22.1 21.4l-5.8-5.8c1.2-1.4 1.9-3.2 1.9-5.2 0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2 3.7 8.2 8.2 8.2c2 0 3.8-.7 5.2-1.9l5.8 5.8zm-18.7-11a6.7 6.7 0 1113.4 0 6.7 6.7 0 01-13.4 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol